import { useRouteSnapshot } from './use-route-snapshot'
import { RouteCoverageSnapshot } from './api/route-coverage-snapshots'

interface ChildProps {
  readonly snapshotLoading: boolean
  readonly snapshotData?: RouteCoverageSnapshot
}

interface RouteSnapshotLoaderProps {
  readonly organizationUuid: string
  readonly applicationUuid: string
  readonly startDate?: Date
  readonly endDate?: Date
  readonly children: (props: ChildProps) => JSX.Element
}

/* This component exists because React hooks need to be called inside of the
top level of a function component. In the route coverage grid, we need to load
the route snapshot after we load the application with ApplicationLoaderCacheFirst
which uses an old version of react-apollo that only allows us to use render prop components,
and not hooks for loading data.

Because of this, we cannot call useRouteSnapshot directly inside of the renderLoaded prop
that is passed to ApplicationLoaderCacheFirst. So, we need a render prop component like this
to call the hook for us instead. View this component's usage in the route coverage grid for
more context. */
export function RouteSnapshotLoader({
  organizationUuid,
  applicationUuid,
  startDate,
  endDate,
  children
}: RouteSnapshotLoaderProps) {
  const { data: snapshotData, isLoading: snapshotLoading } = useRouteSnapshot(
    organizationUuid,
    applicationUuid,
    startDate,
    endDate
  )

  return children({ snapshotLoading, snapshotData })
}
